import {mapToTypeFromString} from '../../../common/common';
export enum HotelRegion {
  AMERICAS = 'Americas',
  GREATER_CHINA = 'Greater China',
  EUROPE = 'Europe',
  AMEA = 'AMEA'
}

export namespace HotelRegion {
  export const fromString = (input: string): HotelRegion => {
    return mapToTypeFromString<HotelRegion>(HotelRegion, input);
  }
  export const isGreaterChina = (input: HotelRegion) => {
    return input && input === HotelRegion.GREATER_CHINA;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/hotel/hotel-region.model.ts